var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-filter-picker',{attrs:{"title":"Custom Filter"}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('till-dynamic-filter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }